// extracted by mini-css-extract-plugin
export default {"wrapper":"ahorraSection_wrapper__RgNon","listItemsRecarga":"ahorraSection_listItemsRecarga__Y6TuH"};